import React, { useState, useEffect } from "react";

const ManageUsername = ({
  id_R,
  closeUsernameModal,
  manageUsernameModalOpen,
  selectedUser,
  updateUsername,
  closeAdminUserModal,
  getAdminUsers,
}) => {
  const [edituserName, setEditUserName] = useState("");
  const [editemail, setEditEmail] = useState("");
  const [changesMade, setChangesMade] = useState(false);

  useEffect(() => {
    if (selectedUser) {
      setEditUserName(selectedUser.username || "");
      setEditEmail(selectedUser.email || "");
    }
  }, [selectedUser]);

  const handleUserNameChange = (e) => {
    setEditUserName(e.target.value);
    setChangesMade(true);
  };

  const handleEmailChange = (e) => {
    setEditEmail(e.target.value);
    setChangesMade(true);
  };

  const handleSaveChanges = async () => {
    try {
      // Call getAddressInfo with the appropriate data
      const response = await updateUsername({
        id: selectedUser?.id,
        email: editemail,
        username: edituserName,
      });

      // Handle the response as needed
      console.log("Backend response:", response);

      closeUsernameModal();
      closeAdminUserModal();
      getAdminUsers();
    } catch (error) {
      // Handle errors
      console.error("Error submitting data:", error);
    }
  };
  return (
    <>
      <div
        id={id_R}
        className={`${
          manageUsernameModalOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow max-w-[100%] mx-auto h-[95vh]">
            <div className="px-4 mt-4 rounded-t flex items-center">
              <div className="flex items-center justify-center rounded-t h-[10vh]">
                <button
                  onClick={closeUsernameModal}
                  type="button"
                  className="bg-transparent  rounded-lg text-sm p-1.5 ml-auto inline-flex items-center "
                  data-modal-toggle={id_R}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                  >
                    <path
                      d="M17.0874 7.48148H4.09029L10.0602 1.50698L8.54369 0L0 8.55026L8.54369 17.1005L10.0495 15.5935L4.09029 9.61905H17.0874V7.48148Z"
                      fill="black"
                    />
                  </svg>
                  <span className="sr-only">Close modal</span>
                  <p className="text-[20px] font-bold text-[#000] ml-5">
                    Manage username
                  </p>
                </button>
              </div>
            </div>
            <div className="flex items-center justify-center w-[58vw] h-[8vh]">
              <div className="w-[95%] text-[#000] text-sm font-normal ">
                <p>
                  ⚠️ Please be aware that changing your username is a sensitive
                  operation. This action will impact how the user is
                </p>
                <p>identified across the platform.</p>
              </div>
            </div>

            <div className="flex items-center justify-between h-[15vh] px-5">
              <div className="flex flex-col justify-center">
                <label
                  htmlFor="nameInput"
                  className="h-[4vh] text-md font-medium text-[#000]"
                >
                  Username
                </label>
                <input
                  type="text"
                  id="nameInput"
                  name="userName"
                  placeholder={selectedUser?.username}
                  value={edituserName}
                  onChange={handleUserNameChange}
                  className="w-[27vw] h-10 px-4 border border-[1px] border-[#000]"
                />
              </div>
              <div className="flex flex-col justify-center">
                <label
                  htmlFor="email"
                  className="h-[4vh] text-md font-medium text-[#000]"
                >
                  Email
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  placeholder={selectedUser?.email}
                  value={editemail}
                  onChange={handleEmailChange}
                  className="w-[27vw] h-10 px-4 border border-[1px] border-[#000]"
                />
              </div>
            </div>

            <div className="flex items-end justify-between h-[52vh] px-5">
              <button
                data-modal-toggle={id_R}
                type="button"
                className={`${
                  changesMade
                    ? "text-white bg-[#005C53] hover:bg-[#005C53]"
                    : "text-[#000] bg-[#D9D9D9] hover:bg-[#D9D9D9]"
                } focus:outline-none focus:ring-blue-300 rounded-[5px] text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10`}
                onClick={handleSaveChanges}
              >
                Save changes
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageUsername;
